import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import Base from './../components/base/index';
import rules from './../rules'
import ValidationContext from './../contexts/ValidationContext'


export default function textareaFactory(WrappedComponent) {
  return class CurstomTextArea extends Base {
    static displayName = `TextAreaFactory(${WrappedComponent.name})`;

    static propTypes = {
      validations: PropTypes.arrayOf(PropTypes.string).isRequired,
      errorClassName: PropTypes.string,
      containerClassName: PropTypes.string,
      errorContainerClassName: PropTypes.string
    };

    static contextType = ValidationContext;

    constructor(props, context) {
      super(props, context);

      this.state = {
        value: props.value,
        isChanged: !!props.value,
        isUsed: false,
        isChecked: true
      };

      context.register(this);
    }

    render() {
      const {
        /* eslint-disable */
        validations,
        /* eslint-enable */
        errorClassName,
        containerClassName,
        errorContainerClassName,
        className,
        ...rest } = this.props;

      // TODO: Refactor conditions
      const isInvalid = this.state.isUsed && this.state.isChanged && !!this.context.errors[this.props.name];
      const error = isInvalid && this.context.errors[this.props.name][0];
      let hint = null;

      if (isInvalid) {
        hint = typeof error === 'function'
          ? error(this.state.value, this.context.components)
          : rules[error].hint(this.state.value, this.context.components);
      }

      return (
        <WrappedComponent
          {...rest}
          containerClassName={cx({
            [containerClassName]: !!containerClassName,
            [errorContainerClassName]: !!error && errorContainerClassName
          })}
          className={cx({
            [className]: !!className,
            [errorClassName]: !!error && errorClassName
          })}
          onChange={this.onChange}
          onBlur={this.onBlur}
          value={this.state.value}
          hint={hint}
        />
      );
    }
  }
}